import { createSlice } from '@reduxjs/toolkit'

export const AppConfigSlice = createSlice({
  name: 'appConfigInfo',
  initialState: {
    isMobileView: false,
  },
  reducers: {
    setIsMobileView: (state, action) => {
      state.isMobileView = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setIsMobileView } = AppConfigSlice.actions

export default AppConfigSlice.reducer